import type { DeepPartial } from '@luna/utils-ts';

import { dashboardATFeatureConfig } from './dashboard/AT';
import { documentsATFeatureConfig } from './documents/AT';
import { exportATFeatureConfig } from './export/AT';
import { miscATFeatureConfig } from './misc/AT';
import { ordersATFeatureConfig } from './orders/AT';
import { overviewATFeatureConfig } from './overview/AT';
import { priceAlertsATFeatureConfig } from './priceAlerts/AT';
import { printATFeatureConfig } from './print/AT';
import { productSettingsATFeatureConfig } from './productSettings/AT';
import { regularOrdersATFeatureConfig } from './regularOrders/AT';
import { searchATFeatureConfig } from './search/AT';
import { statementsATFeatureConfig } from './statements/AT';
import { tradingConfigAT } from './trading/AT';
import { titleDetailATConfig } from './titleDetail/AT';
import type { InvestmentsFeatureConfig } from '../types/InvestmentsFeatureConfig';

export const investments: DeepPartial<InvestmentsFeatureConfig> = {
    dashboard: dashboardATFeatureConfig,
    documents: documentsATFeatureConfig,
    export: exportATFeatureConfig,
    misc: miscATFeatureConfig,
    orders: ordersATFeatureConfig,
    overview: overviewATFeatureConfig,
    priceAlerts: priceAlertsATFeatureConfig,
    print: printATFeatureConfig,
    productSettings: productSettingsATFeatureConfig,
    regularOrders: regularOrdersATFeatureConfig,
    search: searchATFeatureConfig,
    statements: statementsATFeatureConfig,
    titleDetail: titleDetailATConfig,
    trading: tradingConfigAT,
};
